// Copyright (c) 2022 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {putClosingAccount} from '../../shared/repositories';
import {readClosingAccount} from './get-close-account';
import {successAlertBar} from '../../../shared/services/alert-bar';

export const acceptClosingAccount = (closingAccount, selectedAccount) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            await putClosingAccount(closingAccount);

            successAlertBar('TRANSFER_CREATED');

            readClosingAccount(selectedAccount)(dispatch);

        } catch (error) {
        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/put-close-account.js